import Movie from "../assets/imgs/MoviesTrailer.jpg";
import OutDoors from "../assets/imgs/Natours.jpg";
import OmniFood from "../assets/imgs/Omnifood.jpg";
import Raom from "../assets/imgs/raom.jpg";

export const projectsData = [
  {
    img: Raom,
    name: "Ra'om",
    link: "https://raom.om/",
  },
  {
    img: OmniFood,
    name: "Omnifood",
    github: "https://github.com/aljuraysiH/Omnifood",
    link: "https://omnifood-aljuraysi.netlify.app/",
  },
  {
    img: OutDoors,
    name: "Natours",
    github: "https://github.com/aljuraysiH/Natours",
    link: "https://natours-aljuraysi.netlify.app/",
  },
  {
    img: Movie,
    name: "Movie Trailer",
    github: "https://github.com/aljuraysiH/Movies",
    link: "https://movies-trailer.netlify.app/",
  },
];
